import * as React from "react";
import Translate from '../../common/functions/translate';
import * as Constants from '../../common/constants';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import Growl from '../../common/components/alertMessage/growl';
import MedicinesContainer from '../medicines/medicinesContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTablets, faStethoscope, faPills, faPrescription, faMapMarkedAlt, faHeartbeat, faUsers, faVial } from '@fortawesome/free-solid-svg-icons';
import { textAlign } from "@material-ui/system";

interface IProps {
  history: any,
  classes: any,
}

interface IState {
  searchText: string
}

class HomeComponent extends React.Component<IProps, IState> {

  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      searchText: ''
    }
  }

  handleAlphaIndexChange = (e, letter: string) => {
    this.props.history.push(`${Constants.MedicinesUrl}?letter=${encodeURI(letter)}`);
  }

  handleChange = (key, value) => {
    this.setState({ searchText: value });
  };

  handleSearchButtonClick = () => {

    const { searchText } = this.state;

    let searchTextTrim = searchText.trim();

    if (searchTextTrim) {
      this.props.history.push(`${Constants.MedicinesUrl}?searchText=${encodeURI(searchTextTrim)}`);
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick();
    }
  }

  handleMenuItemClick = (menuUrl) => {
    this.props.history.push(menuUrl);
  }

  render() {
    const { searchText } = this.state;
    const { classes } = this.props;

    let inputStyle = window.innerWidth < Constants.device.desktop ? { maxWidth: 600 } : { maxWidth: 600, margin: '0 auto' }

    return (
      <div className="app-home">

        <div className="app-home-content">

          <div className="app-home-header">

            <Growl ref={(el) => this.growl = el} />

            {window.innerWidth < Constants.device.desktop ?
              <div>
                <h1>MedXchange</h1>
                <p>{Translate('MedXchangeDescription')}</p>
              </div> : null}

            <h2>{Translate('SearchMedicineInDatabase')}</h2>

            <div style={inputStyle}>
              <Paper className={classes.root} elevation={1}>
                <InputBase className={classes.input} placeholder={Translate('EnterMedicineName')}
                  onChange={(e) => this.handleChange('searchByName', e.target['value'])}
                  onKeyPress={this.handleKeyPress}
                  value={searchText ? searchText : ""}
                />
                <IconButton
                  color="primary"
                  className={classes.iconButton}
                  onClick={this.handleSearchButtonClick}
                >
                  <SearchIcon />
                </IconButton>
              </Paper>
            </div>
          </div>

          {window.innerWidth >= Constants.device.tablet ?
            <>
              <div>
                <h1>MedXchange</h1>
                <p>{Translate('MedXchangeDescription')}</p>
              </div>

              <div className="circle-container">
                <div className="circle-wrapper">
                  <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.MedicinesUrl)}>
                    <div className="circle-icon">
                      <FontAwesomeIcon icon={faTablets} size={window.innerWidth >= Constants.device.desktop ? "3x" : "2x"} />
                    </div>
                    <div>
                      <div className="circle-title">{Translate('Medicines')}</div>
                      <div className="circle-desc">{Translate('BrowseAllMedicine')}</div>
                    </div>
                  </div>

                  <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.InteractionsUrl)}>
                    <div className="circle-icon">
                      <FontAwesomeIcon icon={faPills} size={window.innerWidth >= Constants.device.desktop ? "3x" : "2x"} />
                    </div>
                    <div>
                      <div className="circle-title">{Translate('Interactions')}</div>
                      <div className="circle-desc">{Translate('Check medicine interactions')}</div>
                    </div>
                  </div>
                </div>
                <div className="circle-wrapper">
                  <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.DiseaseUrl)}>
                    <div className="circle-icon">
                      <FontAwesomeIcon icon={faStethoscope} size={window.innerWidth >= Constants.device.desktop ? "3x" : "2x"} />
                    </div>
                    <div>
                      <div className="circle-title">{Translate('Diseases')}</div>
                      <div className="circle-desc">{Translate('List of all Diseases')}</div>
                    </div>
                  </div>

                  <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.DisposalPlaces)}>
                    <div className="circle-icon">
                      <FontAwesomeIcon icon={faMapMarkedAlt} size={window.innerWidth >= Constants.device.desktop ? "3x" : "2x"} />
                    </div>
                    <div>
                      <div className="circle-title">{Translate('Locations')}</div>
                      <div className="circle-desc">{Translate('DisposalPlaces')}</div>
                    </div>
                  </div>
                </div>
              </div>
            </>
            :
            <div className="circle-container">
              <div className="circle-wrapper" style={{ margin: '15px 0 10px 0' }}>
                <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.MedicinesUrl)}>
                  <div className="circle-icon">
                    <FontAwesomeIcon icon={faTablets} size="2x" />
                  </div>
                  <div>
                    <div className="circle-title">{Translate('Medicines')}</div>
                  </div>
                </div>
                <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.InteractionsUrl)}>
                  <div className="circle-icon">
                    <FontAwesomeIcon icon={faPills} size="2x" />
                  </div>
                  <div>
                    <div className="circle-title">{Translate('Interactions')}</div>
                  </div>
                </div>
              </div>
              <div className="circle-wrapper" style={{ margin: '0 0 10px 0' }}>
                <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.DiseaseUrl)}>
                  <div className="circle-icon">
                    <FontAwesomeIcon icon={faStethoscope} size="2x" />
                  </div>
                  <div>
                    <div className="circle-title">{Translate('Diseases')}</div>
                  </div>
                </div>
                <div className="circle-item" onClick={() => this.handleMenuItemClick(Constants.DisposalPlaces)}>
                  <div className="circle-icon">
                    <FontAwesomeIcon icon={faMapMarkedAlt} size="2x" />
                  </div>
                  <div>
                    <div className="circle-title">{Translate('Locations')}</div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="user-functionalities" style={{ textAlign: 'center' }}>
            <h2>{Translate('User Functionalities')}</h2>
            <div className="wrapper">
              <div className="container">
                <div className="item" onClick={() => this.handleMenuItemClick('/user/medicines')}>
                  <div className="icon">
                    <FontAwesomeIcon icon={faPills} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                  </div>
                  <div className="desc">
                    {Translate('My Medicines')}
                  </div>
                </div>
                <div className="item" onClick={() => this.handleMenuItemClick('/user/diseases')}>
                  <div className="icon">
                    <FontAwesomeIcon icon={faStethoscope} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                  </div>
                  <div className="desc">
                    {Translate('My Diseases')}
                  </div>
                </div>
                <div className="item" onClick={() => this.handleMenuItemClick('/user/prescriptions')}>
                  <div className="icon">
                    <FontAwesomeIcon icon={faPrescription} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                  </div>
                  <div className="desc">
                    {Translate('Doctors prescriptions')}
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="item" onClick={() => this.handleMenuItemClick('/user/condition')}>
                  <div className="icon">
                    <FontAwesomeIcon icon={faHeartbeat} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                  </div>
                  <div className="desc">
                    {Translate('My Condition')}
                  </div>
                </div>
                <div className="item" onClick={() => this.handleMenuItemClick('/user/family')}>
                  <div className="icon">
                    <FontAwesomeIcon icon={faUsers} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                  </div>
                  <div className="desc">
                    {Translate('My Family')}
                  </div>
                </div>
                <div className="item" onClick={() => this.handleMenuItemClick('/user/labresults')}>
                  <div className="icon">
                    <FontAwesomeIcon icon={faVial} size={window.innerWidth >= Constants.device.desktop ? "2x" : "lg"} />
                  </div>
                  <div className="desc">
                    {Translate('Laboratory result')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {window.innerWidth >= Constants.device.desktop ?
            <div className="top-list-medicines">
              <h2>{Translate('Top40MedicineSearches')}</h2>
              <MedicinesContainer topList={10} />
            </div> : null}

          {window.innerWidth < Constants.device.desktop ?
            <div style={{ marginBottom: "80px", marginTop: "10px", textAlign: "center" }}>
              <img src="/images/EU-ProjectInfo.png" />
            </div>
            : null}

        </div>
      </div>
    )
  }
}

export default withStyles(Constants.inputWithButton)(HomeComponent);